import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { reduxForm } from "redux-form";
import Radium from "radium";
import { addAlert } from "../MsgNotify/msgNotifyActions";
import Validator from "../Common/validator";
import auth from "./authService";
import { semanticColors } from "../Globals/styles";

export class Login extends Component {
  async submit(values, dispatch) {
    let uName = values.username + "@ceas.dk";
    if (values.username.includes("@")) {
      uName = values.username;
    }
    await auth.login(uName, values.password, () => {
      dispatch(addAlert("Email og adgangskode passer ikke sammen"));
    });
  }
  componentWillMount = () => {
    this.isUserLoggedIn();
  };
  componentWillReceiveProps = (nextProps) => {
    if (!nextProps.isWaiting) this.isUserLoggedIn();
  };
  isUserLoggedIn = () => {
    if (auth.loggedIn()) {
      window.location.replace(window.location.origin);
    }
  };
  getButtonContet = () => {
    return this.props.isWaiting ? (
      <i style={styles.spinner} className="fa fa-spinner fa-spin"></i>
    ) : (
      "Login"
    );
  };
  render() {
    const {
      fields: { username, password },
      handleSubmit,
      isWaiting,
    } = this.props;
    const isMas = process.env.REACT_APP_title.includes("Mas");
    return (
      <div className="row" style={styles.bodyRow}>
        <div
          className="col-xs-10 col-xs-offset-1 col-sm-6 col-sm-offset-3 col-md-6 col-md-offset-3 col-lg-4 col-lg-offset-4"
          style={styles.container}
        >
          <form method="POST">
            <div className="row" style={styles.logoRow}>
              <div
                className="col-xs-8 col-xs-offset-2 col-md-4 col-md-offset-4"
                style={isMas ? styles.logoMAS : styles.logo}
              ></div>
            </div>
            <div className="row">
              <div
                className="col-md-4 col-md-offset-4 text-center"
                style={styles.titleRow}
              >
                <b>{isMas ? "MAS WEB APP" : "CEAS WEB APP"}</b>
              </div>
            </div>
            {/*
              <div className="row">
                <div className="col-xs-10 col-xs-offset-1 col-md-8 col-md-offset-2" style={styles.loginText}>
                  Kære bruger, <br/> vi har lige lavet en stor opdatering til Appen. <br />
                  Dit brugernavn er blevet ændret til dit ceas løn-nr. din adgangskode er fortsat den samme
                </div>
              </div>*/}
            <div className="row" style={styles.inputRow}>
              <div className="col-xs-10 col-xs-offset-1 col-md-8 col-md-offset-2">
                <Validator
                  msg={username.error}
                  isValid={!username.touched || username.valid}
                >
                  <div className="input-group">
                    <span className="input-group-addon" id="basic-addon1">
                      <i className="fa fa-user"></i>
                    </span>
                    <input
                      ref={(input) => {
                        this.nameInput = input;
                      }}
                      type="text"
                      className="form-control"
                      placeholder="Email eller Løn-nr."
                      {...username}
                    />
                  </div>
                </Validator>
              </div>
            </div>
            <div className="row" style={styles.inputRow}>
              <div className="col-xs-10 col-xs-offset-1 col-md-8 col-md-offset-2">
                <Validator
                  msg={password.error}
                  isValid={!password.touched || password.valid}
                >
                  <div className="input-group">
                    <span className="input-group-addon" id="basic-addon1">
                      <i className="fa fa-lock"></i>
                    </span>
                    <input
                      className="form-control"
                      type="password"
                      placeholder="adgangskode"
                      {...password}
                    />
                  </div>
                </Validator>
              </div>
            </div>
            <div className="row" style={styles.btnRow}>
              <div className="col-xs-8 col-xs-offset-2 col-md-4 col-md-offset-4">
                <button
                  type="submit"
                  className="btn btn-success btn-block waves-btn"
                  onClick={handleSubmit(this.submit)}
                  disabled={isWaiting}
                >
                  {this.getButtonContet()}
                </button>
              </div>
            </div>
            <div
              style={{
                paddingTop: 24,
                paddingBottom: 18,
                textAlign: "center",
                color: semanticColors.info,
                cursor: "pointer",
              }}
              onClick={async () => {
                const value = prompt(
                  "Indtast din email adresse. \nDu vil modtage en email der giver dig mulighed for at nulstille din adgangskode. ",
                  username.touched ? username.value : undefined
                );
                await auth.resetPassword(value);
              }}
            >
              Glemt adgangskode ?
            </div>
          </form>
        </div>
        <div
          style={{
            position: "absolute",
            bottom: 20,
            right: "50%",
            color: "white",
          }}
        >
          v. 2.0.0
        </div>
      </div>
    );
  }
}

var styles = {
  container: {
    border: "1px solid #ccc",
    boxShadow:
      "0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)",
    marginTop: "10%",
    borderRadius: "2px",
    backgroundColor: "#ffffff",
  },
  bodyRow: {
    margin: "0px",
  },
  logoRow: {
    marginBottom: "20px",
    marginTop: "55px",
  },
  titleRow: {
    marginBottom: "25px",
    marginTop: "5px",
  },
  inputRow: {
    padding: "3px 0px",
  },
  btnRow: {
    marginTop: "25px",
    marginBottom: "30px",
  },
  spinner: {
    fontSize: "30px",
    width: "100%",
    lineHeight: "20px",
  },
  loginText: {
    marginBottom: "10px",
  },
  logo: {
    width: "140px",
    height: "140px",
    borderRadius: "100%",
    border: "1px solid #AAA",
    background: 'url("/images/loginLogo1.jpg") no-repeat scroll center center',
    left: "50%",
    marginLeft: "-70px",
  },
  logoMAS: {
    width: "140px",
    height: "140px",
    borderRadius: "100%",
    border: "1px solid #AAA",
    background: 'url("/images/loko.png") no-repeat scroll center center',
    left: "50%",
    marginLeft: "-70px",
  },
};

function selectProps(state) {
  return {
    isWaiting: state.authenticationReducer.isWaiting,
    form: "loginForm",
  };
}

var LoginForm = reduxForm({
  form: "loginForm",
  fields: ["username", "password"],
  validate: validateLogin,
})(Login);

function validateLogin(data) {
  const errors = {};
  if (!data.username) errors.username = "Du skal indtaste din email";
  if (!data.password) errors.password = "Adgangskode skal udfyldes";
  return errors;
}

Login.propTypes = {
  dispatch: PropTypes.func.isRequired,
  fields: PropTypes.object.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  isWaiting: PropTypes.bool.isRequired,
};

export default connect(selectProps)(Radium(LoginForm));



// WEBPACK FOOTER //
// ./src/App/Login/index.jsx